// extracted by mini-css-extract-plugin
export default {"main":"Tag--main--0OCTJ"};